import * as types from "../types/contractDeactivationStatus"

const initialState = {
  isDeactivationWarningSet: false,
  deactivationWarningDate: ""
}

const contractDeactivationStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CONTRACT_DEACTIVATION_STATUS:
      return action.status
    case types.UPDATE_CONTRACT_DEACTIVATION_STATUS:
      return { ...state, ...action.status }
    case types.DELETE_CONTRACT_DEACTIVATION_STATUS:
      return {
        isDeactivationWarningSet: false,
        deactivationWarningDate: ""
      }
    default:
      return state
  }
}

export default contractDeactivationStatusReducer